
<template>
  <aside class="block" :class="option.type" v-if="option.message !== ''" @click="close">
    <p>{{ option.message }}</p>
  </aside>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Snackbar',
  props: {
    option: {
      type: Object,
      require: true,
    },
  },
  methods: {
    close() {
      const option = this.option ?? {};
      option.message = '';
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/const.scss' as *;

.block {
  margin: 0 0 20px;
  @media (min-width: $desktop) {
    margin: 0 40px 20px;
  }

  p {
    margin: 0;
    padding: 10px 20px;
    background-color: var(--bs-gray-200);
    @media (min-width: $desktop) {
      border-radius: 5px;
      box-shadow: 0 0 10px var(--bs-gray-300);
    }
  }

  &.success p {
    background-color: var(--bs-success);
    color: var(--bs-gray-100);
  }
  &.warning p {
    background-color: var(--bs-warning);
  }
}
</style>
